import './styles.css';

import { InboxOutlined } from "@ant-design/icons";
import { Typography, UploadProps } from "antd";
import Dragger from "antd/es/upload/Dragger";

export default function FIDragger({ props, rmSubtitle, disabled }: { props: UploadProps<any>, rmSubtitle?: boolean, disabled?: boolean }) {
    return (
        <Dragger disabled={disabled} {...props}>
            <div className='drag-drop-style'>
                <p className={`ant-upload-drag-icon`}>
                    <InboxOutlined />
                </p>
                <div>
                    <Typography className={'text-title'}>Clique ou arraste o arquivo para esta área para fazer upload</Typography>
                    {!rmSubtitle && <Typography className={'text-subtitle'}>Suporte para upload único ou em massa.</Typography>}
                </div>
            </div>
        </Dragger>
    )
}